import React from 'react';
import { featureId } from '../constants/feature-id';
import { Feature } from 'sollishealth.core.react';

export const HideBehindFeature = ({ children }: React.PropsWithChildren) => (
    <Feature featureId={featureId} overrideForDev={true}>
        {children}
    </Feature>
);